module.exports = "/virtual-football-league/img/amblems/right/logos/AtleticoBilbao.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/AtleticoBilbao.png
// module id = 2156
// module chunks = 4